export const getUserPaymentInformation = (state) => state.payment.userPaymentInformation;
